import React from 'react'
import { FormAbout as Form, ImagePicker } from '.'
import { useViewport, viewportBreakpoint } from '../../../utils'

const ContentOfficialAbout = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  //const isTablet = width >= viewportBreakpoint.tablet && width < viewportBreakpoint.desktop

  return (
    <div className="lg:flex lg:-mx-4 mb-8">
      <div className="w-1/2 lg:w-1/3 lg:px-4 mx-auto lg:mx-0">
        <div className="mx-auto lg:mx-0 my-8 lg:my-0" style={{maxWidth: '170px'}}>
          <ImagePicker />
        </div>
      </div>
      <div className="px-4 ml-auto w-full lg:w-2/3" style={{paddingLeft: isMobile ? '' : ''}}>
        <Form isMobile={isMobile}/>
      </div>
    </div>
  )
}

export { ContentOfficialAbout }
